<script setup>
  import {
    useTheme
  } from 'vuetify'
  import ScrollToTop from '@core/components/ScrollToTop.vue'
  import initCore from '@core/initCore'
  import {
    initConfigStore,
    useConfigStore,
  } from '@core/stores/config'
  import {
    hexToRgb
  } from '@layouts/utils'
  import _ from 'lodash'

  const {
    global
  } = useTheme()

  // ℹ️ Sync current theme with initial loader theme
  initCore()
  initConfigStore()

  // --------------- 👉 User Pinia Store
  import {
    useStore
  } from '@/stores/user'
  const userStore = useStore()
  // --------------- 👉 User Pinia Store
  const featureKeys = userStore.featureKeys.value
  const roles = userStore.roles.value

  const configStore = useConfigStore()
  const {
    isMobile
  } = useDevice()

  configStore.appContentLayoutNav = 'horizontal'
  if (isMobile)
    configStore.appContentLayoutNav = 'vertical'

  const {
    width
  } = useWindowSize();
  // const windowWidth = ref(window.innerWidth)
  watch(width, () => {
    if (!_.includes(userStore.roles, 'distributor_admin')) {
      if (width.value < 680) {
        configStore.appContentLayoutNav = 'vertical'
      } else {
        configStore.appContentLayoutNav = 'horizontal'
      }
    }
  }, {
    immediate: false
  })
</script>

<template>
  <VLocaleProvider :rtl="configStore.isAppRTL">
    <!-- ℹ️ This is required to set the background color of active nav link based on currently active global theme's primary -->
    <VApp :style="`--v-global-theme-primary: ${hexToRgb(global.current.value.colors.primary)}`">
      <NuxtLayout>
        <NuxtPage />
      </NuxtLayout>

      <ScrollToTop />
    </VApp>
  </VLocaleProvider>
</template>